import type { Glyph } from "./types";

export const ArrowLeftIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M22.984 7.293C22.648 6.926 22.079 6.901 21.712 7.236L3.533 23.858C3.346 24.028 3.24 24.269 3.24 24.522C3.24 24.775 3.346 25.017 3.533 25.187L21.712 41.809C22.079 42.144 22.649 42.119 22.984 41.753C23.319 41.386 23.294 40.816 22.927 40.481L6.458 25.422L45.83 25.422C46.327 25.422 46.73 25.019 46.73 24.522C46.73 24.025 46.327 23.623 45.83 23.623L6.458 23.623L22.927 8.564C23.294 8.229 23.319 7.659 22.984 7.293Z" />
  </svg>
);

export default ArrowLeftIcon;
